@if (realEstate && realEstate.images.length > 0) {
  <div class="flex flex-col  content-stretch bg-white col-span-1 h-full rounded-[5px] outline-1 outline-offset-[-1px] outline-gray-200 p-6 md:p-4 items-center">
    <div class="relative w-full mb-5">
      <button
        type="button"
        class="block w-full cursor-pointer text-left"
        aria-label="Ver detalhes do imóvel"
        (click)="navigateToDetails(realEstate.link)">
        <img class="w-full lg:h-70 rounded-[5px] overflow-hidden transition-opacity hover:opacity-90"
             [src]="realEstate.images?.[0]"/>
      </button>
      @if (isRecentlyAdded()) {
        <span class="absolute top-2 right-2 bg-orange-500 text-white text-xs font-medium px-2 py-1 rounded-md shadow">
          RECÉM-ADICIONADO
        </span>
      }
      @if (isAuctionApproaching()) {
        <span
          class="absolute top-2 right-2 bg-red-600 text-white text-xs font-medium px-2 py-1 rounded-md shadow">
          DATA DE LEILÃO SE APROXIMANDO
        </span>
      }
    </div>

    <div class=" flex-col col-span-10  justify-center flow-root" id="same-height">

<!--      <div class="px-3 py-0.5 m-1 bg-green-100 rounded-md inline-block">-->
<!--        <p class="text-center justify-start text-green-800 text-sm font-medium font-['Inter'] leading-tight">-->
<!--          {{ realEstate.source }}-->
<!--        </p>-->
<!--      </div>-->

      @if (isLogged | async) {
        @if (realEstate?.auction_type) {
          <div class="px-3 py-0.5  m-1 bg-green-100 rounded-md inline-block">
            <p class="text-center justify-start text-green-800 text-sm font-medium font-['Inter'] leading-tight">
              {{ realEstate.auction_type }}
            </p>
          </div>
        }
        @if (realEstate?.occupied) {
          <div class="px-3 py-0.5  m-1 bg-green-100 rounded-md inline-block">
            <p class="text-center justify-start text-green-800 text-sm font-medium font-['Inter'] leading-tight">
              Ocupado
            </p>
          </div>
        }
        @if (realEstate?.sale_type) {
          <div class="px-3 py-0.5 m-1 bg-green-100 rounded-md inline-block">
            <p class="text-center justify-start text-green-800 text-sm font-medium font-['Inter'] leading-tight">
              {{ realEstate.sale_type }}
            </p>
          </div>
        }
      }
    </div>

    <div class="mb-5">
      <p class="mt-5 w-full leading-tight text-xl font-semibold text-gray-900 font-['Inter'] ">
        {{ realEstate.real_estate_type }} - {{ realEstate.federation_state }} - {{ realEstate.city }} - {{ realEstate.neighborhood }}</p>
    </div>


    <div class="mt-auto w-full">

      @if (realEstate.assessment_price) {
      <div class=" border-t border-gray-200 pt-2">
        <p class="text-center text-gray-500 text-base font-normal font-['Inter'] leading-normal">Valor avaliado</p>
        <p [class.line-through]=checkAuctionPriceBelowAssessmentPrice() class="text-center
                text-Colors-Indigo
                text-2xl
                font-normal
                font-['Inter']
                leading-loose
                text-indigo-500">
          {{ realEstate.assessment_price | currency: 'BRL' }}
        </p>
      </div>
      }
      <div class="self-center border-t border-b border-gray-200 mt-2 py-3 mx-2">
        @if (realEstate.sale_type == 'Leilão SFI - Edital Único' || realEstate.sale_type == null || !realEstate.sale_type) {
          <div class="flex justify-center items-center mb-2">
            <p class="inline-block text-center text-gray-900 font-extrabold text-2xl font-['Inter']">
              {{ getCurrentAuctionPrice() | currency: 'BRL' }}
            </p>
            @if (getCurrentAuctionDiscount()) {
              <span class="inline-flex items-center px-1 py-0.5 ms-1 rounded-md text-center bg-green-100 text-green-800 text-sm font-medium font-['Inter'] leading-tight">
                  <svg class="w-4 h-4 text-green-800  inline-block" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
                  </svg>{{ getCurrentAuctionDiscount() | number:'.0-0' }}%
                </span>
            }
          </div>

          <div class="">
            <div class="">
              <p [class.line-through]=checkPastDate(realEstate?.auction_1_start_date) class="text-sm block py-1">1ª Leilão {{ realEstate.auction_1_start_date | date:'dd/MM/yy':'UTC' }} LANCE MÍNIMO: {{ realEstate.auction_1_price | currency: 'BRL' }}
                @if(realEstate?.auction_1_discount){
                  <span class="inline-flex items-center px-1 py-0.5 ms-1 rounded-md text-center bg-green-100 text-green-800 text-sm font-medium font-['Inter'] leading-tight">
                  <svg class="w-4 h-4 text-green-800  inline-block" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
                  </svg>{{ realEstate?.auction_1_discount | number:'1.0-0' }}%
                </span>
                }
              </p>


              @if (realEstate.auction_2_start_date) {
              <p [class.line-through]=checkPastDate(realEstate?.auction_2_start_date) class="mt-3 text-sm block py-1">2ª Leilão {{ realEstate.auction_2_start_date | date:'dd/MM/yy':'UTC' }} LANCE MÍNIMO: {{ realEstate.auction_2_price | currency: 'BRL' }}

                @if(realEstate?.auction_2_discount){
                <span class="inline-flex items-center px-1 py-0.5 ms-1 rounded-md text-center bg-green-100 text-green-800 text-sm font-medium font-['Inter'] leading-tight">
                  <svg class="w-4 h-4 text-green-800  inline-block" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
                  </svg>{{ realEstate?.auction_2_discount | number:'1.0-0' }}%
                </span>
                }

              </p>
              }
            </div>
          </div>
        }

        @if (realEstate.sale_type == 'Licitação Aberta') {
<!--          <div class="grid grid-cols-10">-->
<!--            <div class="col-span-4">-->
<!--              <p class="text-sm block py-1">Avaliação</p>-->
<!--            </div>-->
<!--            <div class="col-span-6">-->
<!--              <p class="text-sm block py-1">{{ realEstate.assessment_price | currency: 'BRL' }}</p>-->
<!--            </div>-->
<!--          </div>-->

          <div class="flex items-center justify-between gap-4 py-1">
            <div class="shrink-0">
              <p class="text-sm block">A partir de</p>
            </div>
            <div class="min-w-0 text-right">
              <p class="text-sm block whitespace-nowrap">{{ realEstate.minimum_selling_price | currency: 'BRL' }}
                <span class="inline-flex items-center px-1 py-0.5 ms-1 rounded-md text-center bg-green-100 text-green-800 text-sm font-medium font-['Inter'] leading-tight">
                  <svg class="w-4 h-4 text-green-800  inline-block" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
                  </svg>{{ realEstate?.discount | number:'1.0-0' }}%
                </span>
              </p>
            </div>
          </div>

        }

        @if (realEstate.sale_type == 'Venda Online') {

<!--          <div class="grid grid-cols-10">-->
<!--            <div class="col-span-4">-->
<!--              <p class="text-sm block py-1">Avaliação</p>-->
<!--            </div>-->
<!--            <div class="col-span-6">-->
<!--              <p class="text-sm block py-1">{{ realEstate.assessment_price | currency: 'BRL' }}</p>-->
<!--            </div>-->
<!--          </div>-->

          <div class="flex items-center justify-between gap-4 py-1">
            <div class="shrink-0">
              <p class="text-sm block">A partir de</p>
            </div>
            <div class="min-w-0 text-right">
              <p class="text-sm block whitespace-nowrap">{{ realEstate.minimum_selling_price | currency: 'BRL' }}
                <span class="inline-flex items-center px-1 py-0.5 ms-1 rounded-md text-center bg-green-100 text-green-800 text-sm font-medium font-['Inter'] leading-tight">
                  <svg class="w-4 h-4 text-green-800  inline-block" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
                  </svg>{{ realEstate?.discount | number:'1.0-0' }}%
                </span>
              </p>
            </div>
          </div>
          @if (realEstate.deadline) {
            <div class="flex items-center justify-between gap-4 py-1">
              <div class="shrink-0">
                <p class="text-sm block">Deadline</p>
              </div>
              <div class="min-w-0 text-right">
                <p class="text-sm block whitespace-nowrap">{{ realEstate.deadline | date:'dd/MM/yy HH:mm':'UTC' }}</p>
              </div>
            </div>
          }

        }

        @if (realEstate.sale_type == 'Venda Direta Online') {
<!--          <div class="grid grid-cols-10">-->
<!--            <div class="col-span-4">-->
<!--              <p class="text-sm block py-1">Avaliação</p>-->
<!--            </div>-->
<!--            <div class="col-span-6">-->
<!--              <p class="text-sm block py-1">{{ realEstate.assessment_price | currency: 'BRL' }}</p>-->
<!--            </div>-->
<!--          </div>-->

          <div class="flex items-center justify-between gap-4 py-1">
            <div class="shrink-0">
              <p class="text-sm block">A partir de</p>
            </div>
            <div class="min-w-0 text-right">
              <p class="text-sm block whitespace-nowrap">{{ realEstate.minimum_selling_price | currency: 'BRL' }}
                <span class="inline-flex items-center px-1 py-0.5 ms-1 rounded-md text-center bg-green-100 text-green-800 text-sm font-medium font-['Inter'] leading-tight">
                  <svg class="w-4 h-4 text-green-800  inline-block" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
                  </svg>{{ realEstate?.discount | number:'1.0-0' }}%
                </span>
              </p>
            </div>
          </div>
        }

      </div>

      <div class="mt-5">
      @if ((isLogged | async) && !((favorites | async)?.includes(realEstate.link))) {
        <button type="button"
                class="inline-flex w-full items-center justify-center gap-2 cursor-pointer py-2.5 px-5 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-md border border-gray-200 hover:bg-gray-100 focus:z-10 focus:ring-4 focus:ring-gray-100"
                (click)="includeFavorite(realEstate.link)">
          <svg
            class="h-5 w-5 shrink-0 text-cyan-600" aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12.01 6.001C6.5 1 1 8 5.782 13.001L12.011 20l6.23-7C23 8 17.5 1 12.01 6.002Z"/>
          </svg>
          <span>Adicionar aos favoritos</span>
        </button>
      } @else if ((isLogged | async) && (favorites | async)?.includes(realEstate.link)) {
        <button type="button"
                class="inline-flex w-full items-center justify-center gap-2 cursor-pointer py-2.5 px-5 me-2 mb-2 text-sm font-medium focus:outline-none bg-white rounded-md border border-gray-200 hover:bg-gray-100 focus:z-10 focus:ring-4 focus:ring-gray-100"
                (click)="deleteFavorite(realEstate.link)">
          <svg class="h-5 w-5 shrink-0 text-cyan-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path d="m12.75 20.66 6.184-7.098c2.677-2.884 2.559-6.506.754-8.705-.898-1.095-2.206-1.816-3.72-1.855-1.293-.034-2.652.43-3.963 1.442-1.315-1.012-2.678-1.476-3.973-1.442-1.515.04-2.825.76-3.724 1.855-1.806 2.201-1.915 5.823.772 8.706l6.183 7.097c.19.216.46.34.743.34a.985.985 0 0 0 .743-.34Z"/>
          </svg>
          <span>Remover dos favoritos</span>
        </button>
      }
      <button type="button"
              (click)="navigateToDetails(realEstate.link)"
              class="cursor-pointer text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 text-sm font-medium font-['Inter'] rounded-md text-sm px-5 py-2.5 me-2 w-full mt-1">
        Ver mais informações
      </button>

<!--      <a type="button" [href]="realEstate.link" target="_blank"-->
<!--         class="text-center block cursor-pointer text-blue-600  font-medium font-['Inter'] rounded-md text-sm px-5 py-2.5 me-2 w-full mt-2">-->
<!--        Ver no site do leiloeiro-->
<!--      </a>-->

      </div>
    </div>

  </div>


}

@if (showFavoriteAlertConsentModal) {
  <app-favorite-alert-consent-modal
    [isSaving]="isSavingFavoriteAlertConsent"
    [errorMessage]="favoriteAlertConsentError"
    (accepted)="saveFavoriteAlertConsent(true)"
    (declined)="saveFavoriteAlertConsent(false)">
  </app-favorite-alert-consent-modal>
}
